import { IError } from '@checkout/errors';
import { INotification } from '@checkout/notifications';
import { RootState } from '@checkout/state';
import * as cx from 'classnames';
import { Field, Form, Formik, FormikActions, InjectedFormikProps } from 'formik';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FormikErrorFocus, PasswordField } from '..';
import { Button, MembershipHeader, MessageBox, Section } from '../../presentational';
import messages from './../../../i18n/base-en';
import { passwordResetRequest } from './../../../reducers/checkout';
import { getQueryParametersAsObject as getUrlVars } from './../../../utils/apiUtils';
import * as Styles from './PasswordForgotForm.scss';
import getValidationSchema from './PasswordForgotFormValidationSchema';

interface IOwnProps {}

interface IConnectedProps {
  isFetching: boolean;
  errors?: IError;
  notifications?: INotification;
}

interface IConnectetDispatchProps {
  passwordResetRequest: typeof passwordResetRequest;
}

interface IFormValues {
  forgot: {
    newPassword: string;
  };
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedFormikProps<IOwnProps, IFormValues> & InjectedIntlProps;

class PasswordForgotForm extends React.Component<Props, {}> {

  validationSchema = () => {
    return getValidationSchema(this.props.intl);
  }

  onSubmit = (values: IFormValues, formikBag: FormikActions<IFormValues>) => {
    const urlVars = getUrlVars(location.search);
    const identifier = urlVars.i;
    const id = urlVars.id;
    const { newPassword } = values.forgot;

    this.props.passwordResetRequest({ i: identifier, id, newPassword });
  }

  render() {
    const { intl, isFetching, errors, notifications } = this.props;
    const { formatMessage } = intl;

    const classNames = cx({
      [Styles.wrapper]: true,
      [Styles.loading]: isFetching,
    });

    return (
      <div className={classNames}>
        <MembershipHeader
          title={formatMessage(messages.membership_forgot_password_title)}
          subTitle={formatMessage(messages.membership_forgot_password_subtitle)}
        />
        {errors && errors.uiType === 'inline' && <MessageBox spacingBottom={true} type="error" message={errors.messages[0]} />}
        {notifications && <MessageBox spacingBottom={true} type={notifications.type} message={notifications.messages[0]} />}
        <Formik<IFormValues>
          initialValues={{
            forgot: {
              newPassword: '',
            }
          }}
          validationSchema={this.validationSchema}
          onSubmit={this.onSubmit}
          render={(formik) => {
            return (
              <Form className={Styles.form}>
                <Section>
                  <Field
                    id="forgot.newPassword"
                    name="forgot.newPassword"
                    component={PasswordField}
                    iconTitle={formatMessage(messages.membership_show_password_tooltip)}
                    placeholder={formatMessage(messages.membership_new_password_placeholder)}
                    label={formatMessage(messages.membership_new_password_label)}
                    required={true}
                    type="password"
                    autoComplete="new-password"
                    submitOnEnter={true}
                  />
                </Section>
                <Button type="submit" variant="primary" align="center" size="medium" label={formatMessage(messages.membership_new_password_save)} />

                <FormikErrorFocus formikContext={formik} />
              </Form>
            );
          }}
        />
      </div>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({
      isFetching: state.checkout.isFetching,
      errors: state.checkout.errors,
      notifications: state.checkout.notifications,
    }),
    {
      passwordResetRequest,
    },
  )
)(PasswordForgotForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/PasswordForgotForm/PasswordForgotForm.tsx